import ExtendableError from 'es6-error'

export class AuthenticationError extends ExtendableError{
	constructor(m){
		super(m)
		this.name = 'AuthenticationError'
		this.message = m || 'Not authorized.'
	}
}

export class NoUserError extends ExtendableError{
	constructor(m){
		super(m)
		this.name = 'NoUserError'
		this.message = m || 'No User set.'
	}
}

export class NoTokenError extends ExtendableError{
	constructor(m){
		super(m)
		this.name = 'NoTokenError'
		this.message = m || 'No token available.'
	}
}

export class NoCookieError extends ExtendableError{
	constructor(m){
		super(m)
		this.name = 'NoCookieError'
		this.message = m || 'No cookie available.'
	}
}

export class InvalidTokenError extends ExtendableError{
	constructor(m){
		super(m)
		this.name = 'InvalidTokenError'
		this.message = m || 'Token is invalid.'
	}
}

export class InvalidVehicleError extends ExtendableError{
	constructor(m){
		super(m)
		this.name = 'InvalidVehicleError'
		this.message = m || 'Vehicle is invalid.'
	}
}

export class VehicleSearchError extends ExtendableError{
	constructor(m){
		super(m)
		this.name = 'VehicleSearchError'
		this.message = m || 'Vehicle search error.'
	}
}

export class LoadingInProgressError extends ExtendableError{
	constructor(m){
		super(m)
		this.name = 'LoadingInProgressError'
		this.message = m || 'Already loading.'
	}
}
